import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-amazon_video',
  templateUrl: 'amazon_video.component.html',
  styleUrls: ['amazon_video.component.scss']
})
export class AmazonVideoComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AmazonVideoComponent>
    ) {
    if (data && data.device =='Desktop') {   
        // this.dialogRef.updateSize('50%','50%')
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  

}